<template>
  <div class="l-main">
    <div class="l-main__ctn u-box">
      <div class="c-table-wrapper c-table--online-websites">
        <base-table-component :prop-data="tableData">
          <template v-slot:action>
            <div class="header-table-section">
              Configuration Types
            </div>
            <div class="add-button">
              <div>
                List of configuration types
              </div>
              <div class="add-section" @click="createOrUpdateType()">
                <img src="../../../../../assets/add-button.svg" class="add-button__new" alt=""><span>Add New Configration Type</span>
              </div>
            </div>
          </template>
          <template v-slot:default="slotProps">
            <span class="c-table__btn-wrap">
              <generic-button
                v-if="isDeveloper"
                icon
                transparent
                text-inherit
                @click="createOrUpdateType(slotProps.selected.type)"
              >
                <md-tooltip md-direction="top"> Edit </md-tooltip>
                <img src="../../../../../assets/edit-button.svg" alt="">
              </generic-button>
            </span>

            <span class="c-table__btn-wrap">
              <generic-button
                v-if="isDeveloper"
                icon
                transparent
                text-inherit
                @click="openDeleteModal(slotProps.selected.type)"
              >
                <md-tooltip md-direction="top"> Delete </md-tooltip>
                <img src="../../../../../assets/delete-button.svg" alt="">
              </generic-button>
            </span>
          </template>
        </base-table-component>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BaseTableComponent from '../../../../../shared/table/BaseTableComponent'
import DeleteModalComponent from '../../../../../shared/delete-modal/DeleteModalComponent'
import CreateTypeModal from './create'
import get from 'lodash/get'
import GenericButton from '../../../../../shared/buttons/GenericButton'
import { onlinePermissionsMixin } from "@/mixins/onlinePermissionsMixin";

export default {
  name: "OnlineTypesList",

  components: {
    BaseTableComponent,
    GenericButton,
  },

  mixins: [onlinePermissionsMixin],

  computed: {
    ...mapGetters('account', ['user']),
    ...mapGetters('onlineConfiguration', ['types']),

    tableData() {
      return this.types.map(type => ({
          type: type,
          rowData: {
            name: type.name,
          }
        }));
    },
  },

  created() {
    this.getOnlineConfigurationTypes();
  },

  methods: {
    ...mapActions('onlineConfiguration', [
      'getOnlineConfigurationTypes',
      'deleteOnlineConfigurationType',
    ]),

    goToHome() {
      this.$router.push({ name: 'home' });
    },

    openDeleteModal(selected) {
      this.$modal.show(
          DeleteModalComponent,
          {
            deleteMsg: selected.name,
            propData: selected.id,
            deleteFunction: this.deleteOnlineConfigurationType,
            getDataFunction: this.getOnlineConfigurationTypes,
            pageData: {}
          },
          { height: "auto", scrollable: false, width: "440px" }
      );
    },

    createOrUpdateType(type = {}) {
      this.$modal.show(
          CreateTypeModal,
          {
            type: {
              name: get(type, 'name', ''),
            },
            typeId: get(type, 'id'),
          },
          { height: "auto", scrollable: true }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
